import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <button onClick={() => navigate(-1)} className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 mb-6">
          <ArrowLeft className="w-4 h-4" /> Back
        </button>

        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-xl bg-slate-900 flex items-center justify-center">
            <FileText className="w-5 h-5 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-slate-900">Terms of Service</h1>
            <p className="text-xs text-slate-400">Last updated: March 2026</p>
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 p-8 space-y-6 text-sm text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-base font-bold text-slate-900 mb-2">1. Acceptance of Terms</h2>
            <p>By accessing or using GYNOVATE AI/SI, you agree to be bound by these Terms of Service. The Service is intended exclusively for licensed healthcare professionals. If you are not a licensed medical practitioner, you should not use this Service.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-slate-900 mb-2">2. Nature of the Service</h2>
            <p>GYNOVATE AI/SI is a <strong>clinical decision-support tool</strong>. It provides AI-generated clinical information, protocols, drug doses, and management suggestions based on published medical guidelines. The Service:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Does NOT provide medical diagnosis or treatment</li>
              <li>Does NOT replace professional medical judgement</li>
              <li>Is NOT a substitute for direct patient examination</li>
              <li>Should be used as a reference tool only</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-bold text-slate-900 mb-2">3. User Responsibilities</h2>
            <p>As a user, you agree to:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Use the Service only for lawful clinical reference purposes</li>
              <li><strong>Not enter any Protected Health Information (PHI)</strong> or patient-identifiable data</li>
              <li>Independently verify all AI-generated recommendations before clinical application</li>
              <li>Accept full responsibility for clinical decisions made using information from this Service</li>
              <li>Comply with all applicable medical regulations and ethical guidelines</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-bold text-slate-900 mb-2">4. Data Handling</h2>
            <p>Chat sessions are automatically deleted after 24 hours. No patient data is stored. See our <a href="/privacy" className="text-blue-600 underline">Privacy Policy</a> for full details on data handling practices.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-slate-900 mb-2">5. Limitation of Liability</h2>
            <p>GYNOVATE AI/SI and its creators, including Dr. Vikram Dukle, shall not be liable for any direct, indirect, incidental, or consequential damages arising from the use of AI-generated clinical content. All clinical decisions remain the sole responsibility of the treating physician.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-slate-900 mb-2">6. Intellectual Property</h2>
            <p>The GYNOVATE AI/SI platform, its design, algorithms, and content are the intellectual property of Dr. Vikram Dukle. Unauthorized reproduction, distribution, or commercial use is prohibited.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-slate-900 mb-2">7. Modifications</h2>
            <p>We reserve the right to modify these Terms at any time. Continued use of the Service after changes constitutes acceptance of the modified Terms.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-slate-900 mb-2">8. Governing Law</h2>
            <p>These Terms shall be governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Goa, India.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
